import React, { Fragment } from "react";
import {
  FormControlLabel,
  FormHelperText,
  Grid,
  Radio,
  RadioGroup,
  Typography,
} from "@mui/material";
import { Controller } from "react-hook-form";
import TextOtherField from "../TextOtherField";
import ErrorMessage from "components/form/ErrorMessage";
import checkbox from "assets/wealth/icons/check_box.svg";
import checkboxChecked from "assets/wealth/icons/check_box_checked.svg";
import useDevice from "hooks/useDevice";

const InputContent = ({ listAnswer, control, field, name, disabled }) => {
  const { isMobile } = useDevice();
  const handleChange = (event) => {
    const answer = listAnswer.find(
      (ans) => ans.elementId === Number(event.target.value)
    );
    if (answer && answer?.subType === "OTHER_ANSWER") {
      field.onChange([{ answerId: event.target.value, text: "" }]);
    } else {
      field.onChange([{ answerId: event.target.value }]);
    }
  };
  const value = field.value || [];
  return (
    <RadioGroup
      sx={{
        display: "flex",
        flexDirection: isMobile ? "column" : "row",
        marginLeft: "-4px",
        marginRight: "-4px",
      }}
      value={value[0]?.answerId}
      onChange={handleChange}
    >
      {listAnswer.map((answer) => (
        <Fragment key={answer.elementId}>
          <FormControlLabel
            ref={field.ref}
            value={`${answer.elementId}`}
            disabled={disabled}
            control={
              <Radio
                icon={<img style={{ width: 16 }} src={checkbox} alt="" />}
                checkedIcon={
                  <img style={{ width: 16 }} src={checkboxChecked} alt="" />
                }
                checked={
                  Number(value[0]?.answerId) === Number(answer.elementId) ||
                  answer.answerText !== null
                }
              />
            }
            label={answer.title}
            sx={{
              "& .MuiFormControlLabel-label": {
                fontSize: "0.875rem",
                flex: "1 1",
                wordWrap: "break-word",
                maxWidth: isMobile ? "calc(100% - 2rem)" : "unset",
              },
              "& .MuiFormControlLabel-label.Mui-disabled": {
                color: "#000000",
              },
              "& .MuiRadio-root": {
                padding: "4px",
                marginRight: "8px",
                flexShrink: 0,
              },
              alignItems: "flex-start",
              margin: 0,
              marginBottom: "4px",
              minWidth: isMobile ? "100%" : "calc((100% - 16px) / 3)",
              maxWidth: isMobile ? "100%" : "calc((100% - 16px) / 3)",
            }}
          />
          {((Number(value[0]?.answerId) === Number(answer.elementId) &&
            answer.subType === "OTHER_ANSWER") ||
            (answer.answerText !== null && answer.subType === "OTHER_ANSWER")) && (
            <TextOtherField
              control={control}
              name={`${name}.0.text`}
              answer={answer}
              disabled={disabled}
              value={answer.answerText}
            />
          )}
        </Fragment>
      ))}
    </RadioGroup>
  );
};
const SingleChoiceField = ({
  control,
  name,
  question,
  listAnswer,
  questionIdx,
  disabled,
}) => {
  return (
    <Grid item xs={12} className="!mb-4">
      <Typography
        sx={{
          fontWeight: 600,
          fontSize: "14px",
          color: "#00B74F",
          mb: 0.5,
        }}
      >
        Câu {questionIdx + 1}:
      </Typography>
      <Typography
        sx={{
          fontWeight: 600,
          fontSize: "14px",
          color: "#25282B",
          mb: 1,
          wordWrap: "break-word",
        }}
        className="question-title"
      >
        {question.title}
      </Typography>
      <Controller
        control={control}
        name={name}
        render={({ field, fieldState: { error } }) => {
          return (
            <>
              <FormHelperText error>
                <ErrorMessage message={error?.message} />
              </FormHelperText>
              <InputContent
                field={field}
                name={name}
                control={control}
                listAnswer={listAnswer}
                disabled={disabled}
              />
            </>
          );
        }}
      />
      <div
        className="pt-2"
        dangerouslySetInnerHTML={{ __html: question?.description }}
      />
    </Grid>
  );
};

export default SingleChoiceField;
